<template>
  <Catalog
    title="Город"
    name-label="Название города"
    submit-error="Укажите название города."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "TownCatalog",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getTownById(id);
    },
    async putData(data) {
      return await this.putTown(data)
    },
    async postData(data) {
      return await this.postTown(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Towns/TownCatalog.vue